import { graphql } from "msw";
import currencies from "../data/oms/currencies";

export const handlers = [
  graphql.query("getCurrencies", (req, res, ctx) => {
    return res(
      ctx.delay(600),
      ctx.data({
        getCurrencies: currencies,
      })
    );
  }),
];
